import { ProjectParticipationsT } from '@/components/common/menu/lib/types/navigationDataTypes.ts'

/* return last active stage id if it exists and is valid
 * if stage id is not valid, return first available stage id
 * if there are no available stages, return null
 */
export function validateLastActiveStageId(
  userProjectParticipations: ProjectParticipationsT | undefined,
  lastActiveStageId: string | null | undefined,
  debug = false,
): string | null {
  const availableStagesIds = userProjectParticipations?.map(p => String(p.projectStage?.id)) ?? []

  if (debug) {
    console.log(userProjectParticipations, 'userProjectParticipations ')
  }
  if (availableStagesIds.length === 0) return null

  let firstFAvailableStageId = availableStagesIds[0]

  // user can be removed from the project and still have this stage id stored as lastActiveStageId
  const lastActiveStagesValid = lastActiveStageId && availableStagesIds.includes(lastActiveStageId)

  let stageId = lastActiveStagesValid ? lastActiveStageId : firstFAvailableStageId

  return stageId
}
